import {DxPopupComponent} from 'devextreme-angular/ui/popup';
import {Component, Input, ViewChild} from '@angular/core';
import {AjaxService} from 'AjaxService';

@Component({
    selector: 'app-faq-popup',
    templateUrl: './faq-popup.component.html',
    styleUrls: ['./faq-popup.component.css'],
    standalone: false
})
export class FaqPopupComponent {
  @ViewChild('popup', {static: false}) popup: DxPopupComponent;

  @Input() type: string = 'extern';

  init: boolean = false;
  filteredDatas: any[] = [];
  searchText: string = '';
  _all: any[] = [];

  get all(): any[] {
    return JSON.parse(JSON.stringify(this._all));
  }

  constructor(private ajaxService: AjaxService) {
    this.onClickClose = this.onClickClose.bind(this);
    this.onHiddenPopup = this.onHiddenPopup.bind(this);
  }

  open() {
    this.popup.instance.show();
    this.load();
  }

  onClickClose(e) {
    this.popup.instance.hide();
  }

  onHiddenPopup(e) {
    this.init = false;
    this.searchText = '';
  }

  load() {
    this.ajaxService.post<any[]>('api/Faq/Get', {type: this.type}).subscribe({
      next: (response) => {
        for (let index = 0; index < response.length; index++) {
          response[index].frage = response[index].frage.replace(/(?:\r\n|\r|\n)/g, '<br>');
          response[index].antwort = response[index].antwort.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }

        this._all = response;
        this.filter();
        this.init = true;
      },
      error: (err) => {
        throw err;
      },
    });
  }

  valueChanged(e) {
    if (e.value !== undefined && e.value !== null) {
      this.filter();
    }
  }

  filter() {
    if (this.searchText !== undefined && this.searchText !== null && this.searchText.length > 0) {
      const results = this.all.filter((x) => x.frage.toLowerCase().includes(this.searchText.toLowerCase()) || x.antwort.toLowerCase().includes(this.searchText.toLowerCase()));

      for (let index = 0; index < results.length; index++) {
        results[index].isOpen = true;
        results[index].frage = this.replace(results[index].frage);
        results[index].antwort = this.replace(results[index].antwort);
      }

      this.filteredDatas = results;
    } else {
      this.filteredDatas = this.all;
    }
  }

  replace(text) {
    if (text.toLowerCase().includes(this.searchText.toLowerCase())) {
      let start_index = text.toLowerCase().indexOf(this.searchText.toLowerCase());
      const spanStart = '<span class="faq-popup-item-found">';
      const spanEnd = '</span>';
      const searchTextLower = this.searchText.toLowerCase();

      while (start_index !== -1) {
        if (start_index !== -1) {
          const end_index = start_index + this.searchText.length;
          text = this.insertAt(start_index, text, spanStart);
          text = this.insertAt(end_index + spanStart.length, text, spanEnd);
          start_index = text.toLowerCase().indexOf(searchTextLower, end_index + spanStart.length + spanEnd.length);
        }
      }
    }

    return text;
  }

  insertAt(index, text, replacement) {
    return text.substring(0, index) + replacement + text.substring(index);
  }

  onCollapseClick(e) {
    if (e.isOpen === true) {
      e.isOpen = false;
    } else {
      e.isOpen = true;
    }
  }
}
